import React, { useState, useEffect } from "react";
import "./Login.css";
import loginImage from "../../assets/image/login.png";
import { authAPI } from "../../api/authApi";

function LoginPage() {
    const [showPassword, setShowPassword] = useState(false);
    const [credentials, setCredentials] = useState({
        email: '',
        password: ''
    });
    const [errors, setErrors] = useState({
        email: '',
        password: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(
        localStorage.getItem('rememberMe') === 'true'
    );

    useEffect(() => {
        if (rememberMe) {
            const savedEmail = localStorage.getItem('email');
            if (savedEmail) {
                setCredentials(prev => ({ ...prev, email: savedEmail }));
            }
        }
    }, [rememberMe]);

    useEffect(() => {
        if (localStorage.getItem('token')) {
            window.location.href = '/';
        }
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = { email: '', password: '' };

        if (!credentials.email) {
            newErrors.email = 'Email é obrigatório';
            valid = false;
        } else if (!/\S+@\S+\.\S+/.test(credentials.email)) {
            newErrors.email = 'Email inválido';
            valid = false;
        }

        if (!credentials.password) {
            newErrors.password = 'Senha é obrigatória';
            valid = false;
        } else if (credentials.password.length < 6) {
            newErrors.password = 'Senha deve ter pelo menos 6 caracteres';
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setIsLoading(true);
        try {
            const response = await authAPI.login(credentials);
            localStorage.setItem('token', response.data.token);

            if (rememberMe) {
                localStorage.setItem('rememberMe', 'true');
                localStorage.setItem('email', credentials.email);
            } else {
                localStorage.removeItem('rememberMe');
                localStorage.removeItem('email');
            }

            window.location.href = '/';
        } catch (error) {
            console.error('Erro no login:', error);
            //TODO: Implementar um sistema de notificação mais robusto
            alert(error.response?.data?.message || 'Erro ao fazer login');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="loginPage-container">
            <div className="loginPage-leftSection">
                <img
                    src={loginImage}
                    alt="Login"
                    className="loginPage-leftImage"
                />
            </div>
            <div className="loginPage-rightSection">
                <div className="loginPage-formWrapper">
                    <h2>Acesse a plataforma</h2>
                    <p>
                        Faça login para gerenciar o controle <br />
                        de segurança com{" "}
                        <span className="loginPage-highlight">eficiência.</span>
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="loginPage-inputGroup">
                            <label htmlFor="email" className="loginPage-label">Email</label>
                            <div className="loginPage-inputContainer">
                                <i className="fa fa-envelope loginPage-icon"></i>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className={`loginPage-input ${errors.email ? 'input-error' : ''}`}
                                    placeholder="Email"
                                    value={credentials.email}
                                    onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                                    autoComplete="username"
                                />
                            </div>
                            {errors.email && <span className="error-message">{errors.email}</span>}
                        </div>

                        <div className="loginPage-inputGroup">
                            <label htmlFor="password" className="loginPage-label">Senha</label>
                            <div className="loginPage-inputContainer">
                                <i className="fa fa-lock loginPage-icon"></i>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    className={`loginPage-input ${errors.password ? 'input-error' : ''}`}
                                    placeholder="Senha"
                                    value={credentials.password}
                                    onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                                    autoComplete="current-password"
                                />
                                <i
                                    className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} loginPage-passwordToggle`}
                                    onClick={togglePasswordVisibility}
                                ></i>
                            </div>
                            {errors.password && <span className="error-message">{errors.password}</span>}
                        </div>

                        <div className="loginPage-options">
                            <label className="loginPage-remember">
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={() => setRememberMe(!rememberMe)}
                                /> Lembrar-me
                            </label>
                            <a className="loginPage-forgotLink" href="/forgot-password">Esqueceu a senha?</a>
                        </div>

                        <div className="loginPage-buttonGroup">
                            <button
                                type="submit"
                                className="loginPage-button"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin"></i> Carregando...
                                    </>
                                ) : (
                                    'Entrar'
                                )}
                            </button>
                        </div>
                    </form>
                    <div className="loginPage-faqWrapper">
                        <a className="loginPage-faqLink" href="/faq">
                            Saiba mais
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;